import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=3e589b34&scoped=true&"
import script from "./VendorList.vue?vue&type=script&lang=js&"
export * from "./VendorList.vue?vue&type=script&lang=js&"
import style0 from "./VendorList.vue?vue&type=style&index=0&id=3e589b34&lang=scss&scoped=true&"
import style1 from "./VendorList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e589b34",
  null
  
)

export default component.exports